export default "__VITE_ASSET__hJcGEIez__"